import $ from 'jquery';

export default class Contacts {
	constructor() {
		this.selectors = {
			el: '.js-contacts-form',
			radio: '.js-contacts-radio',
			input: '.js-contacts-input'
		};

		this.classes = {
			error: 'field__input_state_error'
		};

		this.$el = $(this.selectors.el);
		this.$radio = this.$el.find(this.selectors.radio);
		this.$input = this.$el.find(this.selectors.input);
	}

	setRequired = el => {
		const type = el.data('type');
		const $input = this.$input.filter(`[data-type="${type}"]`);
		this.$input.removeAttr('required');
		this.$input.removeClass(this.classes.error);
		$input.attr('required', true);
	}

	onRadioChange = e => {
		const $target = $(e.target);
		this.setRequired($target);
	}

	render = () => {
		if (this.$el.length) {
			this.$radio.on('change', this.onRadioChange);
		}

	}

}



/** WEBPACK FOOTER **
 ** ./app/blocks/contacts/contacts.js
 **/